export enum DanfeLabelBarcodeMode {
  Native = 'native'
}
